import React from "react";

const SpendinglyPrivacyPolicy = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> February 2026</p>

        <p>
          Spendingly operates the Spendingly mobile application ("App").
          This Privacy Policy explains how information is handled when you use our App.
        </p>

        <h2>1. App Overview</h2>
        <p>
          Spendingly is a personal expense tracking application that allows users
          to record expenses, track income, and manage personal financial records.
        </p>
        <p>
          The App does <strong>not</strong> provide banking, lending, investment,
          insurance, money transfer, or financial advisory services.
        </p>

        <h2>2. Information We Collect</h2>

        <h3>2.1 Financial Information (Stored Locally Only)</h3>
        <p>
          When using the App, you may enter financial data such as:
        </p>
        <ul>
          <li>Expense records</li>
          <li>Income records</li>
          <li>Categories</li>
          <li>Notes</li>
        </ul>

        <p>
          All financial data is stored <strong>locally on your device only</strong>.
          We do not upload, store, transmit, or share your financial data to any external servers.
        </p>

        <h3>2.2 Advertising & Device Data</h3>
        <p>
          If the App displays advertisements (such as Google AdMob), third-party
          advertising providers may automatically collect:
        </p>
        <ul>
          <li>Device identifiers (Advertising ID)</li>
          <li>IP address</li>
          <li>Basic usage data</li>
          <li>Diagnostic information</li>
        </ul>

        <p>
          This data is used solely for delivering and improving advertisements.
          We do not control third-party data collection practices.
        </p>

        <p>
          Google Privacy Policy:{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy
          </a>
        </p>

        <h2>3. Data Storage & Security</h2>
        <p>
          All financial records are stored locally using secure device storage.
          We do not operate remote servers to store user financial data.
        </p>

        <p>
          Users are responsible for securing their device. The App may provide
          biometric authentication (Face ID / Fingerprint) for additional protection.
        </p>

        <h2>4. Data Sharing</h2>
        <p>
          We do not sell, trade, rent, or share your financial information.
        </p>
        <p>
          Information may only be disclosed if required by law or to comply
          with legal obligations.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          Since financial data is stored locally:
        </p>
        <ul>
          <li>Data remains on your device until deleted by you</li>
          <li>Uninstalling the app removes local data</li>
          <li>You may clear data through device settings</li>
        </ul>

        <h2>6. Children's Privacy</h2>
        <p>
          Spendingly is not directed toward children under 13 years of age.
          We do not knowingly collect personal information from children.
        </p>

        <h2>7. Your Rights</h2>
        <p>
          Depending on your jurisdiction, you may have rights under applicable
          data protection laws, including access, correction, or deletion of personal data.
        </p>
        <p>
          Because we do not store financial data on external servers,
          data control remains entirely on your device.
        </p>

        <h2>8. Third-Party Services</h2>
        <p>The App may use third-party services including:</p>
        <ul>
          <li>Google AdMob</li>
          <li>Google Play Services</li>
          <li>Apple App Store Services</li>
        </ul>

        <p>
          These services operate under their own privacy policies.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically.
          Changes will be reflected by updating the “Last updated” date.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have any questions regarding this Privacy Policy, you may contact:
        </p>
        <p>
          Email: delighcodeinfotech@gmail.com
        </p>

        <footer style={styles.footer}>
          © 2026 Spendingly. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    backgroundColor: "#f4f6f9",
    padding: "40px 20px",
    minHeight: "100vh"
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.8",
    color: "#333"
  },
  footer: {
    marginTop: "40px",
    fontSize: "14px",
    color: "#777"
  }
};

export default SpendinglyPrivacyPolicy;
